export default function mtaReducer(
    state: any = {
        submit: null,
        bound: null,
        policy: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        summary: {
            loading: false,
            done: false,
            error: null,
            response: {},
        },
        cal_mta: {
            loading: false,
        },
        mta_bound: {
            loading: false,
            error: false,
            success: false,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get policy info
         */
        case 'GET_POLICY_MTA_PENDING': {
            return {
                ...state,
                policy: {
                    ...state.policy,
                    loading: true,
                },
            }
        }

        case 'GET_POLICY_MTA_REJECTED': {
            return {
                ...state,
                policy: {
                    ...state.policy,
                    loading: false,
                    error: action.payload,
                },
            }
        }

        case 'GET_POLICY_MTA_FULFILLED': {
            return {
                ...state, policy: {
                    ...state.policy,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload.policy,
                },
            }
        }

        /**
         *     Get Summary
         */
        case 'GET_MTA_PREVIEW_PENDING': {
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: true,
                },
            }
        }

        case 'GET_MTA_PREVIEW_REJECTED': {
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false,
                    error: action.payload,
                },
            }
        }

        case 'GET_MTA_PREVIEW_FULFILLED': {
            return {
                ...state, summary: {
                    ...state.summary,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload.mta,
                },
            }
        }

        /**
         *  Add MTA
         */
        case 'ADD_MTA_PENDING': {
            return {
                ...state,
                cal_mta: {
                    loading: true,
                },
            }
        }
        case 'ADD_MTA_FULFILLED': {
            return {
                ...state,
                cal_mta: {
                    loading: false,
                },
                submit: action.payload,
            }
        }
        case 'ADD_MTA_REJECTED': {
            return {
                ...state,
                cal_mta: {
                    loading: false,
                },
            }
        }

        /**
         *  Add MTA
         */
        case 'BIND_MTA_PENDING': {
            return {
                ...state,
                mta_bound: {
                    loading: true,
                    error: false,
                    success: false,
                },
            }
        }
        case 'BIND_MTA_FULFILLED': {
            return {
                ...state,
                bound: true,
                mta_bound: {
                    loading: false,
                    error: false,
                    success: true,
                },
            }
        }
        case 'BIND_MTA_REJECTED': {
            return {
                ...state,
                mta_bound: {
                    loading: false,
                    error: action.payload.error,
                    success: false,
                },
            }
        }

        /**
         *  Reset MTA
         */
        case 'RESET_MTA': {
            return {
                submit: null,
                bound: null,
                policy: {
                    loading: false,
                    done: false,
                    error: null,
                    response: {},
                },
                summary: {
                    loading: false,
                    done: false,
                    error: null,
                    response: {},
                },
                cal_mta: {
                    loading: false,
                },
                mta_bound: {
                    loading: false,
                    error: false,
                    success: false,
                },
            }
        }

        /**
         * Remove policy submit
         */

        case 'REMOVE_POLICY_SUBMIT': {
            return {
                ...state,
                submit: null,
            }
        }
        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/policies/mta.ts